import { type ComponentProps, type FC } from 'react';
import { cn } from '../lib/utils';
import {
  InputGroupAddon,
  InputGroupButton,
  InputGroupInput,
  InputGroupText,
  InputGroupTextarea,
  InputGroup as UiInputGroup,
} from './ui/input-group';

type InputGroupProps = ComponentProps<typeof UiInputGroup>;

/** Override ui/input-group `dark:bg-input/30` → Figma `background/surface`. */
export const InputGroup: FC<InputGroupProps> = ({ className, ...props }) => (
  <UiInputGroup {...props} className={cn('dark:bg-background-surface', className)} />
);

export { InputGroupAddon, InputGroupButton, InputGroupInput, InputGroupText, InputGroupTextarea };
